<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.marvei_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Modelos
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.marvei_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 20%">Código</th>
                                <th style="width: 30%">Descrição</th>
                                <th style="width: 10%">Código ERP</th>
                                <th style="width: 10%">Status</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.modelo_veiculo">
                                <td>
                                    {{ item.cd}}
                                </td>
                                <td>
                                    {{ item.descr}}
                                </td>
                                <td>
                                    {{ item.cd_erp}}
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                </td>
                                <td>
                                    <span v-if="getPermissionFw('marcaveiculo.status')">
                                        <a v-if="item.status.valor==2" @click="onActivateDesactivate(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                        <a v-if="item.status.valor==1" @click="onActivateDesactivate(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
            <ModeloVeiculoForm
                ref="modeloveiculoform" :tabela="'modelo_veiculo'" :rota="'modeloveiculo'">
            </ModeloVeiculoForm>
		</div>
    </div>
  </template>

  <script>

  import ModeloVeiculoForm from './ModeloVeiculoForm'

  export default {
      components: {
          ModeloVeiculoForm,
      },
      data () {
        return {
          helpForm: new Form({recordCollection: [], status: '', params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onActivateDesactivate(action, data, tipo)
        {console.log(1);
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {
                this.helpForm.recordCollection = [];
                this.helpForm.recordCollection.push(data.modvei_id );
            }
            else
            {
                this.helpForm.recordCollection = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.recordCollection.push(obj)
                });
            }
            this.$refs.modeloveiculoform.onActivateDesactivate(this.helpForm);
        },
    },
  }
  </script>
